import CredentialsService from '@/services/credentials.service'
import store from '@/store/store'
import { actionTypes } from '@/store/actionTypes'
import $utils from '@/utils/utils'
import $http from '@/plugins/axios'
import AppService from '@/services/app.service'

const ApiCode = {
    SPEECH_TO_TEXT: 'asr_hmi',
    TEXT_TO_SPEECH: 'tts_hmi',
    ID: 'id_vision',
    DRIVER_LICENSE: 'dl_vision',
    FACE_MATCH: 'face_vision',
    PASSPORT: 'passport_vision',
    CREDIT_SCORE: 'creditscoring_dmp',
    LIVENESS: 'liveness',
    READER: 'general_ocr'
}

let apiColorMap = {
    [ApiCode.SPEECH_TO_TEXT]: $utils.colorSamples[0],
    [ApiCode.TEXT_TO_SPEECH]: $utils.colorSamples[1],
    [ApiCode.ID]: $utils.colorSamples[2],
    [ApiCode.DRIVER_LICENSE]: $utils.colorSamples[3],
    [ApiCode.FACE_MATCH]: $utils.colorSamples[4],
    [ApiCode.PASSPORT]: $utils.colorSamples[5],
    [ApiCode.CREDIT_SCORE]: $utils.colorSamples[6]
}

let apiUnitMap = {
    [ApiCode.SPEECH_TO_TEXT]: 'block',
    [ApiCode.TEXT_TO_SPEECH]: 'character',
    [ApiCode.ID]: 'request',
    [ApiCode.DRIVER_LICENSE]: 'request',
    [ApiCode.FACE_MATCH]: 'request',
    [ApiCode.PASSPORT]: 'request',
    [ApiCode.CREDIT_SCORE]: 'request'
}

let apiNameMap = {
    [ApiCode.SPEECH_TO_TEXT]: 'Speech to text',
    [ApiCode.TEXT_TO_SPEECH]: 'Text to speech',
    [ApiCode.ID]: 'ID recognition',
    [ApiCode.DRIVER_LICENSE]: 'Driver license recognition',
    [ApiCode.FACE_MATCH]: 'Face matching',
    [ApiCode.PASSPORT]: 'Passport recognition',
    [ApiCode.CREDIT_SCORE]: 'Credit scoring'
}

const ApiService = {
    ApiCode: ApiCode,

    async getListCategories (projectId = 1) {
        try {
            const response = await $http.get(`projects/${projectId}/categories/`)
            return response.data
        } catch (e) {
            return null
        }
    },
    async getDetailsAPIKey (apiKeyId = 1) {
        try {
            const response = await $http.get(`apis/${apiKeyId}`)
            return response.data
        } catch (e) {
            return null
        }
    },
    async toggleAPIThenDemo (projectId = null, apiKey = {}, toggleComplete = null, createKeyComplete = null) {
        let confirm = await window.vueapp.$appService.confirm(
            apiKey.enable
                ? window.vueapp.$t('confirmDisableApi')
                : window.vueapp.$t('confirmEnableApi')
        )
        if (!confirm) {
            return null
        }
        let result = await this.toggleAPIKey(projectId, apiKey)
        if (result) {
            if (toggleComplete) {
                toggleComplete(result)
            }
            if (result.enable) {
                let listApiKey = await CredentialsService.getListCredentials(store.getters.currentProjectId)
                if (listApiKey.length < 1) {
                    let createKeyResult = await window.vueapp.$appService.createApiKey()
                    if (createKeyComplete) {
                        createKeyComplete(createKeyResult)
                    }
                }
                window.vueapp.$router.push(
                    store.getters.token && store.getters.currentProjectId
                        ? `/project/${store.getters.currentProjectId}/apis/${apiKey.id}?tab=service`
                        : `/apis/${apiKey.id}`
                )
            }
        } else {
            AppService.toastError(window.vueapp.$t('actionFailed', {
                action: apiKey.enable ? window.vueapp.$t('disable') : window.vueapp.$t('enable'),
                item: 'api'
            }))
        }
    },
    toggleAPIKey (projectId = null, apiKey = {}) {
        if (apiKey.enable) {
            return this.disableAPIKey(projectId, apiKey.id)
        } else {
            return this.enableAPIKey(projectId, apiKey.id)
        }
    },
    async tryTTSPremium (projectId = null) {
        if (!projectId) {
            projectId = await window.vueapp.$appService.selectProject()
            store.dispatch(actionTypes.user.CURRENT_PROJECT_ID, projectId)
        }
        try {
            const response = await $http.post(`projects/${projectId}/try-tts-premium/`, null)
            return response.data
        } catch (e) {
            return null
        }
    },
    async enableAPIKey (projectId = null, apiKeyId = null) {
        if (!projectId) {
            projectId = await window.vueapp.$appService.selectProject()
            store.dispatch(actionTypes.user.CURRENT_PROJECT_ID, projectId)
        }
        try {
            const response = await $http.put(`projects/${projectId}/enable-api/${apiKeyId}/`, null)
            return response.data
        } catch (e) {
            return null
        }
    },
    async disableAPIKey (projectId = 1, apiKeyId = 1) {
        try {
            const response = await $http.put(`projects/${projectId}/disable-api/${apiKeyId}/`, null)
            return response.data
        } catch (e) {
            return null
        }
    },
    async getAPIKeyEnable (projectId = 1) {
        try {
            const response = await $http.get(`projects/${projectId}/apis/`)
            return response.data
        } catch (e) {
            return null
        }
    },
    async getAPIStatus (projectId = 1, apiKeyId = 1) {
        try {
            const response = await $http.get(`projects/${projectId}/enable-api/${apiKeyId}/`)
            return response.data
        } catch (e) {
            console.log(e)
            return null
        }
    },
    getListApis () {
        return $http.get('/apis/')
    },
    getApiById (apiId) {
        return $http.get(`/apis/${apiId}/`)
    },
    assignApiToProjectStarted (projectId, ApiId) {
        return $http.put(`/projects/${projectId}/enable-api/${ApiId}/`)
    },
    getApiPricingInformation (apiId) {
        return $http.get(`/apis/${apiId}/pricing/`)
    },
    getListApiByProjects (projectId) {
        return $http.get(`/projects/${projectId}/categories/`)
    },
    getCategories () {
        return $http.get(`/categories/`)
    },
    buyPackage (projectId, packageId, urlCallback, urlDetail) {
        return $http.post(
            `/projects/${projectId}/buy-api-package/`,
            {
                'package_id': packageId,
                'url_success': urlCallback,
                'url_detail': urlDetail
            }
        )
    },
    checkValidPayment (queryString) {
        return $http.get(
            `/vnpay-check-payment-return?${queryString}`
        )
    },
    getRemain (projectId, apiId) {
        return $http.get(`/projects/${projectId}/api-remaining/${apiId}/`)
    },
    getApiColor (apiCode) {
        return apiColorMap[apiCode] ? apiColorMap[apiCode] : null
    },
    getApiUnit (apiCode) {
        return apiUnitMap[apiCode] ? apiUnitMap[apiCode] : null
    },
    getApiName (apiCode) {
        return apiNameMap[apiCode] ? apiNameMap[apiCode] : null
    }
}

export default ApiService
